/* eslint-disable react-hooks/exhaustive-deps */
// NOTE: This view is not gated by Permissions.js - the nav item uses Admin.DataMgmt.Read as a best guess,
// but the container itself does not enforce it. No dedicated Acumatica Logs permission exists yet.
import { FETCH_ACUMATICA_FAILURE_LOGS_FAILURE } from './store/acumaticaLogTypes';
import { Box } from '@mui/material';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import AcumaticaLogs from './acumaticaLogs.container';
import { setPageTitle, showToast } from 'modules/layout/layout.actions';
import { getAcumaticaFailurelogs } from './store/acumaticaLogs.actions';
import React, { useEffect, useState } from 'react';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  },
  selfServicePolicySelect: {
    minWidth: 300
  }
});

const AcumaticaLogsView = props => {
  const failedLogs = props.acumaticaFailureLogs ?? [];
  const [failedLogsState, setFailedLogsState] = useState(failedLogs);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    props.setPageTitle('Acumatica Failure Logs');

    async function fetchData() {
      setIsLoading(true);
      if (!failedLogsState || failedLogsState.length === 0) {
        const resp = await props.getAcumaticaFailurelogs();
        if (resp.type === FETCH_ACUMATICA_FAILURE_LOGS_FAILURE) {
          props.showToast('Error fetching Acumatica failure logs', {
            severity: TOAST_MESSAGE_SEVERITY_ERROR
          });
        } else {
          setFailedLogsState(resp.response);
        }
      }
      setIsLoading(false);
    }

    fetchData();
  }, []);

  return (
    <Box>
      {!isLoading && <AcumaticaLogs failedLogs={failedLogsState} />}
      {isLoading && <FullscreenSpinner />}
    </Box>
  );
};

const mapStateToProps = state => {
  const { acumaticaFailureLogs } = state.acumaticaLogs;

  return {
    acumaticaFailureLogs
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    setPageTitle,
    showToast,
    getAcumaticaFailurelogs
  })
)(AcumaticaLogsView);
